export function isEmptyOrWhitespace(str: string) {
  return /^\s*$/.test(str)
}
